import { createComponent } from '@carvana/vdp-components';

export const LowResultWrapper = createComponent('section', {
  className:
    'relative w-[calc(100%_+_32px)] left-[-16px] m:left-0 m:static m:w-full flex flex-col text-center items-center my-48 py-[95px] bg-blue-4 text-white'
});

export const Heading = createComponent('h1', {
  className: 'w-[72%] m:w-full font-bold text-3xl uppercase mb-16'
});

export const Subtitle = createComponent('p', {
  className: 'w-[68%] l:w-full text-l m:text-xl mb-32'
});

export const SaveSearchButton = createComponent('button', {
  className:
    'w-4/5 m:w-full text-white text-sm font-bold uppercase w-full max-w-[307px] rounded bg-blue-4 border-0 h-56'
});

export const SimilarResultsHeader = createComponent('div', {
  className:
    'uppercase text-base font-bold px-16 pb-40 w-full text-center m:pb-48 l:px-40'
});
